import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { cohortUrl } from '@/constants/urls';
import paging from '@/hooks/paging';
import { fetchCohorts } from '../actions';

const CohortMenuItems = ({ cohorts, fetchData, readStatus }) => {
  paging.useFetchByCategory(fetchData, 'ribbon', readStatus);
  return (
    cohorts.map((cohort) => (
      <Dropdown.Item
        key={`cohorts_menu_${cohort.id}`}
        as="a"
        href={cohortUrl(cohort, '#')}
        selected={false}
      >
        <Icon name="favorite" className="primary" />
        {cohort.name}
      </Dropdown.Item>
    ))
  );
};

const mapStateToProps = ({
  cohorts: { cohorts },
}, { category }) => {
  const { results, readStatus } = cohorts[category];

  return ({ cohorts: results, readStatus });
};

const mapDispatchToProps = {
  fetchData: fetchCohorts,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortMenuItems);
